import { createSlice } from "@reduxjs/toolkit";
import cookies from "js-cookie";

import { mapToUserState } from "@mappers/mapToUserState";
import { checkIsLoggedIn } from "@store/thunks/user";
import { ACCESS_TOKEN } from "@constants/common";

import type { User } from "@interfaces/user";

export type AuthState = {
  isAuth?: boolean;
  isLoading: boolean;
  user: User | null;
};

const initialState: AuthState = { isAuth: false, isLoading: false, user: null };

export const userSlice = createSlice({
  name: "USER",
  initialState,

  reducers: {
    logOut: (state) => {
      cookies.remove(ACCESS_TOKEN);
      state.user = null;
      state.isAuth = false;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(checkIsLoggedIn.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(checkIsLoggedIn.fulfilled, (state, { payload }) => {
      if (payload) {
        state.isAuth = true;
        state.isLoading = false;
        state.user = mapToUserState(payload);
      }
    });
  },
});

export const { logOut } = userSlice.actions;

export default userSlice.reducer;
